import { render, staticRenderFns } from "./OrdersRefundedCms.vue?vue&type=template&id=08291bd4&scoped=true"
import script from "./OrdersRefundedCms.vue?vue&type=script&lang=js"
export * from "./OrdersRefundedCms.vue?vue&type=script&lang=js"
import style0 from "./OrdersRefundedCms.vue?vue&type=style&index=0&id=08291bd4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08291bd4",
  null
  
)

export default component.exports